export interface FormatRelativeDayLabelOptions {
  date: Date;
  locale?: string;
  todayLabel?: string;
  yesterdayLabel?: string;
  now?: Date;
}

export const formatRelativeDayLabel = ({
  date,
  locale = 'ru-RU',
  todayLabel = 'Сегодня',
  yesterdayLabel = 'Вчера',
  now = new Date(),
}: FormatRelativeDayLabelOptions) => {
  const today = now;
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return todayLabel;
  }

  if (date.toDateString() === yesterday.toDateString()) {
    return yesterdayLabel;
  }

  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};
